/*
 * BASESUN — JP/KR approximate local-currency hint (display only).
 * 顾客实际仍以 USD 结算；这里只在日本(JP)/韩国(KR)市场的价格下方显示「约 ¥/₩」参考值。
 * 汇率：开放汇率 API（无密钥）实时获取，localStorage 缓存 24h，失败时用兜底常量。
 * 国家来源：window.LP_FX_COUNTRY（由 Liquid 注入 localization.country.iso_code）；
 *           ?lpfxc=JP|KR 查询参数可强制（仅供 QA，无 VPN 也能预览）。
 */
(function () {
  function qp(k) { try { return new URLSearchParams(location.search).get(k); } catch (e) { return null; } }
  var country = (qp('lpfxc') || window.LP_FX_COUNTRY || '').toString().toUpperCase();

  var CFG = {
    JP: { cur: 'JPY', sym: '¥', fb: 160,  approx: '約', note: '※米ドルでのお支払い' },   // 約 ¥… ※米ドルでのお支払い
    KR: { cur: 'KRW', sym: '₩', fb: 1510, approx: '약', note: '※USD로 결제' }                 // 약 ₩… ※USD로 결제
  };
  var cfg = CFG[country];
  if (!cfg) {
    window.LPFx = { active: false, note: '', format: function () { return ''; }, formatCents: function () { return ''; }, onReady: function () {} };
    return;
  }

  var rate = cfg.fb;
  var ready = false;
  var cbs = [];
  function notify() { ready = true; for (var i = 0; i < cbs.length; i++) { try { cbs[i](); } catch (e) {} } }
  function onReady(cb) { if (typeof cb === 'function') { cbs.push(cb); if (ready) cb(); } }

  function fromUsd(usd) {
    var n = Number(usd);
    if (!isFinite(n)) return '';
    return cfg.approx + ' ' + cfg.sym + Math.round(n * rate).toLocaleString('en-US');
  }

  function loadRate() {
    try {
      var c = JSON.parse(localStorage.getItem('lpFxRates') || 'null');
      if (c && c.t && (Date.now() - c.t < 86400000) && c.r && c.r[cfg.cur]) { rate = c.r[cfg.cur]; notify(); return; }
    } catch (e) {}
    fetch('https://open.er-api.com/v6/latest/USD')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.rates && d.rates[cfg.cur]) {
          rate = d.rates[cfg.cur];
          try { localStorage.setItem('lpFxRates', JSON.stringify({ t: Date.now(), r: d.rates })); } catch (e) {}
        }
        notify();
      })
      .catch(function () { notify(); });
  }

  window.LPFx = {
    active: true,
    currency: cfg.cur,
    note: cfg.note,
    format: fromUsd,                                   // 入参：美元金额，如 44.99
    formatCents: function (c) { return fromUsd((Number(c) || 0) / 100); },
    onReady: onReady
  };

  loadRate();

  function numFromText(t) {
    if (!t) return null;
    var n = parseFloat(String(t).replace(/[^\d.,]/g, '').replace(/,/g, ''));
    return isFinite(n) ? n : null;
  }

  // 写入估算文本；只有变化时才写，避免 MutationObserver 自触发循环
  function paint(host, usd) {
    if (!host) return;
    if (usd == null) { if (host.style.display !== 'none') host.style.display = 'none'; return; }
    var txt = fromUsd(usd) + ' ' + cfg.note;
    if (host.textContent !== txt) host.textContent = txt;
    if (host.style.display !== 'block') host.style.display = 'block';
  }

  function watch(observeEl, render) {
    render();
    onReady(render);
    try { new MutationObserver(render).observe(observeEl, { childList: true, subtree: true, characterData: true }); } catch (e) {}
  }

  // ---- 产品页：Dawn 价格下方 ----
  function readUsd(priceEl) {
    if (!priceEl) return null;
    var sale = priceEl.querySelector('.price__sale .price-item--sale');
    var el = (sale && sale.offsetParent !== null && /\d/.test(sale.textContent))
      ? sale
      : (priceEl.querySelector('.price-item--regular') || priceEl.querySelector('.price-item'));
    return el ? numFromText(el.textContent) : null;
  }
  function initProductPage() {
    var host = document.getElementById('lp-fx-estimate');
    if (!host) return;
    var scope = host.closest('product-info') || host.closest('.product__info-wrapper') || document;
    var priceEl = scope.querySelector('.price');
    if (!priceEl) return;
    watch(priceEl, function () { paint(host, readUsd(priceEl)); });
  }

  // ---- 购物车页 /cart：Dawn 合计下方 ----
  function initCartPage() {
    var root = document.getElementById('main-cart-footer');
    if (!root) return;
    watch(root, function () {
      var host = document.getElementById('lp-cart-fx-estimate');
      var total = root.querySelector('.totals__total-value');
      paint(host, total ? numFromText(total.textContent) : null);
    });
  }

  function init() { initProductPage(); initCartPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
